import { useEffect, useState } from "react";
import MainHeader from "../../Components/MainHeader/MainHeader";
import { useThunk } from "../../hooks/use-thunks";
import { addDealer } from "../../store";
import { UTILITY_State_name_url } from "../../Essentials/variables";
import axios from "axios";
import { v4 as uuidv4 } from 'uuid';
import { Dealer_URL } from "../../Essentials/variables";
function DealerSignupPage(props){
    
    const [message,setMessage]=useState('');
    
    const handleFormSubmit=(e)=>{
        // console.log({dealerName,ownerName,state,mobileno,email,password});
        e.preventDefault();
        // console.log(doCreateDealer({dealerName,ownerName,state,mobileno,email,password}));
        axios({
            method:'POST',
            data:{
                dealerName,
                ownerName,
                state,
                mobileno,
                email,
                password,
                id:uuidv4()
            },
            withCredentials:false,
            url:Dealer_URL
          })
          .then((res)=>{
            //   console.log(res.data);  //data: "Success Autheticated"
              if(res.data?.message==="inserted successfully"){
                // console.log("Saving....");
                // localStorage.setItem("token", JSON.stringify(res.data["token"]));
                // localStorage.setItem("userInfo",JSON.stringify(_.omit(res.data,["token"])));
                  props.nav('/gis')
              }
              else{
                setMessage(res.data); 
                // console.log(res.data);
              }
              // console.log(res.data.Access);
          }
          )
    
    }
    const handleLoginPageClick = () =>{
        props.nav('/');
    }
    // console.log(isCreatingDealer);
    // console.log(creatingDealerError);


    const [dealerName,setDealerName]=useState('');
    const [ownerName,setOwnerName]=useState('');
    const [state,setState]=useState('');
    const [mobileno,setMobileno]=useState('');
    const [email,setEmail]=useState('');
    const [password,setPassword]=useState('');
    const [stateapiData,setstateapiData]=useState([]);

        
    const getDetails = async()=>{
        const response = await axios.get(UTILITY_State_name_url);
        // console.log();
        response.data.map((namep,index)=>{
            setstateapiData(stateapiData=>[...stateapiData,namep.state_desc]);
            return stateapiData;
        })
       }
  

    return <div className="bg-gray-50 pb-24">
        <MainHeader profileVisiblilty={false}/>
        <section className="bg-gray-50 dark:bg-gray-900  pt-6">
  <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto lg:py-0">
      <div className="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
          <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
              <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
                  Create an account
              </h1>
              <form className="space-y-4 md:space-y-6" onSubmit={handleFormSubmit}>
                  <div>
                      <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Your email</label>
                      <input type="email" value={email} onChange={(e)=>setEmail(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="name@company.com" required=""/>
                  </div>
                  <div>
                      <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Password</label>
                      <input type="password" value={password} onChange={(e)=>setPassword(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" required=""/>
                  </div>
                  <div>
                      <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Owner Name</label>
                      <input  value={ownerName} onChange={(e)=>setOwnerName(e.target.value)}  className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" required=""/>
                  </div>
                  <div>
                      <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Dealer Name</label>
                      <input  value={dealerName} onChange={(e)=>setDealerName(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" required=""/>
                  </div>
                  <div>
                      <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">State</label>
                      <select placeholder="Enter pincode first" onClick={getDetails} onChange={(e)=>setState(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" id="grid-state">
                          {
                           stateapiData.map((option,ind) => (
                             <option key={ind} value={option}>{option}</option>
                          ))}
                      </select>
                      {/* <input  value={state} onChange={(e)=>setState(e.target.value)} onClick={getDetails} className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" required=""/> */}
                  </div>
                  <div>
                      <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Mobile Number</label>
                      <input  value={mobileno} onChange={(e)=>setMobileno(e.target.value)}  className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" required=""/>
                  </div>
                    <button type="submit" className="w-full text-white bg-[#2563eb] hover:bg-[#1d4ed8] focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">Create an account</button>
                    {message && <p className="text-red-500 text-xs italic">{message} <a onClick={handleLoginPageClick} href="#" className="font-medium text-primary-600 hover:underline dark:text-primary-500">Login here</a></p>}
                    {!message &&<p className="text-sm font-light text-gray-500 dark:text-gray-400">
                      Already have an account? <a onClick={handleLoginPageClick} href="#" className="font-medium text-primary-600 hover:underline dark:text-primary-500">Login here</a>
                    </p>}
              </form>
          </div>
      </div>
  </div>
</section>
    </div>
}

export default DealerSignupPage;